window.addEventListener('DOMContentLoaded', function () {
    const featuredCollection = document.querySelectorAll('.ft-collection');
    // Changed to querySelectorAll for consistency, but note that this will require adjustments in how you add or remove classes and styles
    const ftCollectionGrid = document.querySelectorAll('.ft-product-grid');
    const ftCollectionsControls = document.querySelectorAll('.ft-collecion-ui-controls');
    
    let ftCollectionGridItems = document.querySelectorAll('.ft-product-grid li');
    let ftCollectionSwiper = null;

    function addSwiperCollection() {
        ftCollectionGridItems = document.querySelectorAll('.ft-product-grid li');
        
        if (window.innerWidth < 581) {
            if (ftCollectionSwiper === null) {
                featuredCollection.forEach(collection => collection.classList.add('ft-collection-swiper'));
                ftCollectionGrid.forEach(grid => {
                    grid.classList.add('swiper-wrapper');
                    grid.classList.remove('grid');
                });
                ftCollectionsControls.forEach(control => control.style.display = 'flex');
                ftCollectionGridItems.forEach((item) => {
                    item.classList.add('swiper-slide');
                });

                ftCollectionSwiper = new Swiper('.ft-collection-swiper', {
                    direction: 'horizontal',
                    slidesPerView: 1,
                    spaceBetween: 10,
                    centeredSlides: true,
                    loop: false,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    navigation: {
                        nextEl: '.ft-swiper-button-next',
                        prevEl: '.ft-swiper-button-prev',
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                    },
                });
            }
        } else {
            if (ftCollectionSwiper !== null) {
                ftCollectionSwiper.destroy();
                ftCollectionSwiper = null;
            }
            featuredCollection.forEach(collection => collection.classList.remove('ft-collection-swiper'));
            ftCollectionGrid.forEach(grid => {
                grid.classList.remove('swiper-wrapper');
                grid.classList.add('grid');
            });
            ftCollectionsControls.forEach(control => control.style.display = 'none');
            ftCollectionGridItems.forEach((item) => {
                item.classList.remove('swiper-slide');
            });
        }
    }

    addSwiperCollection();
    window.addEventListener('resize', () => {
        addSwiperCollection();
    });
});